function Footer() {
  return (
    <div className="footer">
      Copyright © 2026
      <span className="credit">
        {" "}
        site made by <a href="https://github.com/floralfish">floralfish</a>
      </span>
    </div>
  );
}
export default Footer;
